import React from 'react';

import CustomersHeader from './components/customers/CustomersHeader';
import UserManagementHeader from './components/user-management/UserManagementHeader';
import ProjectsHeader from './components/projects/ProjectsHeader';
import SettingsHeader from './components/settings/SettingsHeader';
import SonarDashboardHeader from './components/sonar-dashboard/SonarDashboardHeader';
import ScoutHeader from './components/scout/ScoutHeader';
import SonarDataTableSwitch from './components/sonar-dashboard/SonarDataTableSwitch';
import SonarSettings from './components/sonar-dashboard/SonarSettings';
import AiPlaygroundHeader from './components/ai-playground/AiPlaygroundHeader';
import ResonanceHeader from './components/resonance/ResonanceHeader';
import ResonanceIvisButton from './components/resonance/ResonanceIvisButton';
import GenieHeader from './components/genie/GenieHeader';
import GenieGoHeader from './components/genie-go/GenieGoHeader';
import Id8Header from './components/id8/Id8Header';
import SonarCommonHeader from './components/sonar-common/SonarCommonHeader';
import ProjectRequestHeader from './components/project-request/ProjectRequestHeader';
import Activ8Header from './components/activ8/Activ8Header';
import MediaStudioHeader from './components/media-studio/MediaStudioHeader';

export const APP_HEADER_PRIMARY_ROUTES = [
  { path: '/project/sonar/:id', element: <SonarDashboardHeader />, mobileActionsWrapper: true },
  { path: '/project/sonar/collect-data/:id', element: <SonarCommonHeader /> },
  { path: '/customers/*', element: <CustomersHeader /> },
  { path: '/users/*', element: <UserManagementHeader /> },
  { path: '/projects/*', element: <ProjectsHeader />, mobileActionsWrapper: true },
  { path: '/project/scout/*', element: <ScoutHeader /> },
  { path: '/project/genie/:id', element: <GenieHeader /> },
  { path: '/project/genie-go/:id', element: <GenieGoHeader /> },
  { path: '/project/id8/:id', element: <Id8Header /> },
  { path: '/project/activ8/:id', element: <Activ8Header /> },
  { path: '/project/scout/collect-data/*', element: <ScoutHeader /> },
  { path: '/settings/*', element: <SettingsHeader /> },
  { path: '/playground', element: <AiPlaygroundHeader /> },
  { path: '/media-studio', element: <MediaStudioHeader /> },
  { path: '/project/resonance/:id', element: <ResonanceHeader /> },
  { path: '/project-request', element: <ProjectRequestHeader /> },
];

export const APP_HEADER_ACTION_ROUTES = [
  {
    path: '/project/sonar/:id',
    element: (
      <>
        <SonarSettings />
        <SonarDataTableSwitch />
      </>
    ),
  },
  { path: '/project/resonance/:id', element: <ResonanceIvisButton /> },
];
